import { render, staticRenderFns } from "./allUsersReport.vue?vue&type=template&id=c480fffe"
import script from "./allUsersReport.vue?vue&type=script&lang=js"
export * from "./allUsersReport.vue?vue&type=script&lang=js"
import style0 from "./allUsersReport.vue?vue&type=style&index=0&id=c480fffe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports